// src/app/services/fonasa-voucher.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { URL_SERVICIOS } from '../config/config';


export interface CreateVoucherRequest {
  consultaId: number;
  runBeneficiario: string;
  codigoPrestacion: string;
  practitionerNombre: string;
  practitionerRun: string;
  fechaExpiracionISO?: string;
}

export interface CreateVoucherResponse {
  pagoIdInterno: number;
  voucherId: string;
  folio: string | null;
  status: string;
  paymentUrl: string | null; // OJO: createVoucher devuelve camelCase
  amount: {
    montoBonificado: number | null;
    montoCopago: number | null;
    montoPrestamo: number | null;
    montoTotal: number | null;
  };
}

export interface VoucherStatusResponse {
  consulta_id: number;
  voucher_id: string;
  folio: string | null;
  status: string;
  payment_url: string | null;
  amount_monto_bonificado: number | null;
  amount_monto_copago: number | null;
  amount_monto_prestamo: number | null;
  amount_monto_total: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class FonasaVoucherService {

  constructor(private http: HttpClient) { }


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       callBackSnabb        /////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async callBackSnabb(data){
    // console.log('(S) callBackSnabb');

    let params = {
      "id": data.id,
      "status": "Pending",
      "folio": data.transaction.folio,
      "paymentInfo": {
        "paymentUrl": data.transaction.paymentUrl,
      },
      "amount": {
        "montoBonificado": data.transaction.amount.montoBonificado,
        "montoCopago": data.transaction.amount.montoCopago,
        "montoPrestamo": data.transaction.amount.montoPrestamo,
        "montoTotal": data.transaction.amount.montoTotal
      }
    };

    // console.log(params);

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postFonasaSnabbCallback', params, {}).toPromise()
      return data
    }
    catch (error) {
      // this._errors.requestError(error);
      throw error;
    }

  }

  createVoucher(payload: CreateVoucherRequest, token: string): Observable<CreateVoucherResponse> {

    const httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };


    return this.http.post<CreateVoucherResponse>(URL_SERVICIOS + `/postCrearVoucherFonasa`, payload, httpOptions);

  }

  getVoucherStatus(voucherId: string): Observable<VoucherStatusResponse> {
    return this.http.get<VoucherStatusResponse>(URL_SERVICIOS + `/postFonasaVoucherStatus/${voucherId}`);
  }

}
